var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClear({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    display: "block",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#E1E7F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.86076 5.14768C5.66385 4.95077 5.34459 4.95077 5.14768 5.14768C4.95077 5.34459 4.95077 5.66385 5.14768 5.86076L7.28692 8L5.14768 10.1392C4.95077 10.3361 4.95077 10.6554 5.14768 10.8523C5.34459 11.0492 5.66385 11.0492 5.86076 10.8523L8 8.71308L10.1392 10.8523C10.3361 11.0492 10.6554 11.0492 10.8523 10.8523C11.0492 10.6554 11.0492 10.3361 10.8523 10.1392L8.71308 8L10.8523 5.86077C11.0492 5.66386 11.0492 5.3446 10.8523 5.14769C10.6554 4.95078 10.3361 4.95078 10.1392 5.14769L8 7.28692L5.86076 5.14768Z",
    fill: "#717C8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/clear.ee5f43995ab57ce650096f634dc6ae66.svg";
export { ForwardRef as ReactComponent };